module.exports = __webpack_public_path__ + "static/media/illustration-step-5-securing-the-sample.4a7ae60e.svg";